'use strict';

wbApp.factory('employeeSvc', ['$resource', '$cacheFactory', '$q', 'repositorySvc', 'domainsSvc',
    function ($resource, $cacheFactory, $q, repositorySvc, domainsSvc) {
        var Employee = $resource('/Api/Employees/:id', {}, {
            'getAll': { method: 'GET', isArray: true, url: '/Api/Employees/GetAll' },
            'getByEmployeeID': { method: 'GET', isArray: false, url: '/Api/Employees/GetByEmployeeID' },
            'getBriefByEmployeeID': { method: 'GET', isArray: false, url: '/Api/Employees/GetBriefByEmployeeID' },
            'update': { method: 'POST', url: '/Api/Employees/Update' },
            'insert': { method: 'POST', url: '/Api/Employees/Insert' },
            'delete': { method: 'POST', url: '/Api/Employees/Delete' },
            'domainsGetAll': { method: 'GET', isArray: true, url: '/restapi/employees/:employeeId/domains' },
            'domainsInsert': { method: 'POST', url: '/restapi/employees/:employeeId/domains' },
            'domainsUpdate': { method: 'PUT', url: '/restapi/employees/:employeeId/domains/:id' },
            'domainsDelete': { method: 'DELETE', url: '/restapi/employees/:employeeId/domains/:id' },
            'getAllExpanded': { method: 'GET', isArray: true, url: '/restapi/employees' },
            'getAllExpandedByIds': { method: 'POST', isArray: true, url: '/restapi/employees/find-by-ids' },
            'schedulesUpdateDay': { method: 'PUT', url: '/restapi/employees/:employeeId/schedules/:id' },
            'schedulesDeleteDay': { method: 'DELETE', url: '/restapi/employees/:employeeId/schedules/:id' },
        });

        function createNew() {
            return {
                active: true,
                smallImageUrl: 'https://gaxb7o2ddx-images.storage.googleapis.com/Profile/0/cf2830ffb3df4d72a4cbbc8f88fa3c8a.png',
                franchises: []
            };
        }

        let cache = $cacheFactory('employeeSvcCache');
        let lastUpdatedCache = moment().subtract(1, 'days');
        
        function getAllAsync() {
            
            let cachedData = cache.get('allEmployees');
            if (cachedData && moment().diff(lastUpdatedCache, 'seconds') < 60) {
                return cachedData;
            }
            
            let ret = repositorySvc.customGet('getAll', Employee);

            ret.$promise.then(function (data) {
                _.forEach(data, function (employee) {
                    employee.rfidCardIDsStr = _.join(employee.rfidCardIDs, ', ')
                });
                cache.put('allEmployees', data);
                lastUpdatedCache = moment();
            });

            return ret;
        }

        function getAllNonDeleted(refresh) {
            var allEmployees = getAllAsync(refresh);
            var filteredEmployees = [];

            var deferred = $q.defer();
            filteredEmployees.$promise = deferred.promise;

            allEmployees.$promise.then(function (data) {
                angular.forEach(data, function (value, key) {
                    if (!value.isDeleted) {
                        filteredEmployees.push(value);
                    }
                });
                deferred.resolve(filteredEmployees);
            }, function (reason) {
                deferred.reject(reason);
            });

            return filteredEmployees;
        }

        function getByEmployeeID(employeeID) {
            return repositorySvc.customGet('getByEmployeeID', Employee, {
                employeeID: employeeID
            });
        }

        function getBriefByEmployeeID(employeeID) {
            return repositorySvc.customGet('getBriefByEmployeeID', Employee, {
                employeeID: employeeID
            });
        }

        function getAllActiveAsync(employeeIDtoInclude) {
            
            let alwaysIncludeIds = [];
            
            if (!!employeeIDtoInclude && typeof employeeIDtoInclude === "string") {
                alwaysIncludeIds = employeeIDtoInclude.split(',').map(function (id) {
                    return parseInt(id);
                });
            } else if (employeeIDtoInclude && !_.isNaN(employeeIDtoInclude)) {
                alwaysIncludeIds = [employeeIDtoInclude];
            }
            
            let allEmployees = getAllAsync();
            let filteredEmployees = [];

            let deferred = $q.defer();
            filteredEmployees.$promise = deferred.promise;

            allEmployees.$promise.then(function (data) {
                angular.forEach(data, function (value, key) {
                    if ((!value.isDeleted && value.active) || alwaysIncludeIds.includes(value.employeeID)) {
                        filteredEmployees.push(value);
                    }
                });
                deferred.resolve(filteredEmployees);
            }, function (reason) {
                deferred.reject(reason);
            });

            return filteredEmployees;
        }

        function insert(data, successCallback, errorCallback, collection) {
            lastUpdatedCache = moment().subtract(1, 'days');
            repositorySvc.insert(
                Employee,                  // $resource
                collection,                // collection
                data,                      // entity
                successCallback,
                errorCallback,
                'employeeID');
        }

        function update(data, successCallback, errorCallback, collection) {
            lastUpdatedCache = moment().subtract(1, 'days');
            repositorySvc.update(
                Employee,                   // $resource
                collection,                 // collection
                data,                       // entity
                successCallback,
                errorCallback,
                'employeeID');
        }

        function remove(data, successCallback, errorCallback, collection) {
            lastUpdatedCache = moment().subtract(1, 'days');
            repositorySvc.remove(
                Employee,                    // $resource
                collection,                  // collection
                data,                        // entity
                successCallback,
                errorCallback,
                { employeeID: data.employeeID },
                'employeeID');
        }

        function initNewFranchisesLicense(employee) {
            employee.franchises.push({
                employeeFranchiseID: 0,
                franchiseCentralTenantID: null,
                active: false,
                licenses: []
            });
        }

        function getEmployeeDomains(employeeId) {
            if (!employeeId) {
                return $q(function (resolve, reject) {
                    resolve([]);
                });
            } else {
                return repositorySvc.customGet(
                    'domainsGetAll',
                    Employee,
                    {
                        employeeId: employeeId
                    });
            }
        }

        function loadDomainsData(employeeId) {
            return $q(function (resolve, reject) {
                $q.all([
                   domainsSvc.getAllExpanded().$promise,
                   getEmployeeDomains(employeeId).$promise])
               .then(function (data) {
                   var domains = data[0];
                   var employeeDomains = data[1];

                   var selection = _.flatMapDeep(employeeDomains, function (d) {
                       return [d.domainId, d.specializationIds];
                   });

                   resolve({ domains: domains, selection: selection });
               }, function (error) {
                   reject(error);
               });
            });
        }

        function saveDomainsData(employeeId, domains, origSelection, newSelection, success, error) {

            var origSelectionDict = _.keyBy(origSelection, function (o) { return o; })
            var newSelectionDict = _.keyBy(newSelection, function (o) { return o; })

            var toInsert = [];
            var toUpdate = [];
            var toDelete = [];

            var promisses = [];

            _.forEach(domains, function (d) {

                var origEmployeeDomain = {
                    id: null,
                    domainId: null,
                    specializationIds: []
                };

                var newEmployeeDomain = {
                    id: null,
                    domainId: null,
                    specializationIds: []
                }

                _.forEach(d.specializations, function (s) {
                    if (_.has(origSelectionDict, s.id)) {
                        origEmployeeDomain.specializationIds.push(s.id);
                    }

                    if (_.has(newSelectionDict, s.id)) {
                        newEmployeeDomain.specializationIds.push(s.id);
                    }
                });

                if (origEmployeeDomain.specializationIds.length || _.has(origSelectionDict, d.id)) {
                    origEmployeeDomain.id = d.id;
                    origEmployeeDomain.domainId = d.id;
                }

                if (newEmployeeDomain.specializationIds.length || _.has(newSelectionDict, d.id)) {
                    newEmployeeDomain.id = d.id;
                    newEmployeeDomain.domainId = d.id;
                }

                if (!!origEmployeeDomain.id && !newEmployeeDomain.id) {
                    toDelete.push(origEmployeeDomain);
                }

                if (!origEmployeeDomain.id && !!newEmployeeDomain.id) {
                    toInsert.push(newEmployeeDomain);
                }

                if (!!origEmployeeDomain.id && !!newEmployeeDomain.id) {
                    if (!_.isEqual(origEmployeeDomain, newEmployeeDomain)) {
                        toUpdate.push(newEmployeeDomain);
                    }
                }
            });

            _.forEach(toInsert, function (o) {
                promisses.push(
                    repositorySvc.customPutWithParams('domainsInsert', Employee, { employeeId: employeeId }, o).$promise);
            });
            _.forEach(toUpdate, function (o) {
                promisses.push(
                    repositorySvc.customPutWithParams('domainsUpdate', Employee, { employeeId: employeeId, id: o.id }, o).$promise);
            });
            _.forEach(toDelete, function (o) {
                promisses.push(
                    repositorySvc.customDelete('domainsDelete', Employee, { employeeId: employeeId, id: o.id }).$promise);
            });

            if (promisses.length == 0) {
                success();
            } else {
                $q.all(promisses).then(function (data) {
                    success(data);
                }, function (e) {
                    error(e);
                });
            }
        }

        function schedulesUpdateDay(employeeId, day, dayScheduleDTO) {
            lastLoadedAllExpanded = null;

            return repositorySvc.customPutWithParams(
                'schedulesUpdateDay',
                Employee,
                {
                    employeeId: employeeId,
                    id: moment(day).format('YYYY-MM-DD')
                },
                dayScheduleDTO);
        }

        function schedulesDeleteDay(employeeId, day) {
            lastLoadedAllExpanded = null;

            return repositorySvc.customDelete(
                'schedulesDeleteDay',
                Employee,
                {
                    employeeId: employeeId,
                    id: moment(day).format('YYYY-MM-DD')
                });
        }

        function getAllExpandedByIds(from, to, selectedEmployees) {
            return $q(function (resolve, reject) {
                var result = Employee['getAllExpandedByIds'](
                    {
                        ids: selectedEmployees,
                        expanded: 'AvailabilitySchedules,Schedules,Domains',
                        from: from,
                        to: to
                    },
                    function (success) {
                        _.forEach(result, function (e) {
                            e.fullName = String.prototype.fullName(e.name, e.middlename, e.surname);
                        });

                        resolve(result);
                    },
                    function (error) {
                        repositorySvc.defaultErrorHandler(error);
                        reject(error);
                    })
            });
        }

        var lastLoadedAllExpanded = null;
        var lastLoadedAllExpandedFilter = {
            from: null,
            to: null,
            loadedAt: moment()
        };

        function getAllExpanded(from, to) {

            var mnow = moment();
            if (!lastLoadedAllExpanded ||
                !moment(lastLoadedAllExpandedFilter.from).isSame(from) ||
                !moment(lastLoadedAllExpandedFilter.to).isSame(to) ||
                lastLoadedAllExpandedFilter.loadedAt.isBefore(mnow)) {

                lastLoadedAllExpandedFilter = {
                    from: from,
                    to: to,
                    loadedAt: moment().add(10, 'seconds')
                };

                lastLoadedAllExpanded = $q(function (resolve, reject) {
                    var result = Employee['getAllExpanded'](
                        {
                            expanded: 'AvailabilitySchedules,Schedules,Domains',
                            from: from,
                            to: to
                        },
                        function (success) {
                            _.forEach(result, function (e) {
                                e.fullName = String.prototype.fullName(e.name, e.middlename, e.surname);
                            });
                            resolve(result);
                        },
                        function (error) {
                            reject(error);
                        })
                });
            }

            return lastLoadedAllExpanded;
        }

        function getAll() 
        {
            return $q(function (resolve, reject) {
                var result = repositorySvc.customGet(
                    'getAllExpanded',
                    Employee,
                    function (success) {
                        _.forEach(result, function (e) {
                            e.fullName = String.prototype.fullName(e.name, e.middlename, e.surname);
                        });
                        resolve(result);
                    },
                    function (error) {
                        reject(error);
                    })
            });
        }

        return {
            createNew: createNew,
            getByEmployeeID: getByEmployeeID,
            getBriefByEmployeeID: getBriefByEmployeeID,
            getAllAsync: getAllAsync,
            getAllActiveAsync: getAllActiveAsync,
            insert: insert,
            update: update,
            remove: remove,
            initNewFranchisesLicense: initNewFranchisesLicense,
            getAllNonDeleted: getAllNonDeleted,
            loadDomainsData: loadDomainsData,
            saveDomainsData: saveDomainsData,

            getAllExpandedByIds: getAllExpandedByIds,
            getAll: getAll,
            getAllExpanded: getAllExpanded,

            schedulesUpdateDay: schedulesUpdateDay,
            schedulesDeleteDay: schedulesDeleteDay
        }
    }]);